<div *nzModalTitle></div>
@if (sharingIsLoading) {
  <korviu-loader></korviu-loader>
}
<div class="flex flex-col items-center gap-4">
  <div class="flex flex-col items-center justify-center">
    <i nz-icon class="pb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
        <mask
          id="mask0_12909_233960"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="49"
          height="48"
        >
          <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_12909_233960)">
          <path
            d="M25.5 34C26.0667 34 26.5417 33.8083 26.925 33.425C27.3083 33.0417 27.5 32.5667 27.5 32C27.5 31.4333 27.3083 30.9583 26.925 30.575C26.5417 30.1917 26.0667 30 25.5 30C24.9333 30 24.4583 30.1917 24.075 30.575C23.6917 30.9583 23.5 31.4333 23.5 32C23.5 32.5667 23.6917 33.0417 24.075 33.425C24.4583 33.8083 24.9333 34 25.5 34ZM23.5 26H27.5V14H23.5V26ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.3667 43.925 31.8C42.875 34.2333 41.45 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
            fill="#F28334"
          />
        </g>
      </svg>
    </i>
    <span class="paragraph-large bold">{{ 'balance.sharingConfirmation' | translate }}</span>
  </div>
  <div class="inline-block text-pretty text-center">
    <span class="paragraph-medium outfit">{{ 'balance.are_you_sure' | translate }} </span> &nbsp;
    <span class="font-bold outfit paragraph-medium"
      >{{ data?.amountToSend || '' }}{{ 'balance.ganas' | translate }}</span
    >&nbsp;
    <span class="paragraph-medium outfit">{{ 'balance.once_you_proceed' | translate }}</span>
  </div>
</div>
<div *nzModalFooter class="flex justify-end gap-2">
  <korviu-button color="ghost" (click)="modalRef.close(false)" class="w-full">{{
    'common.cancel' | translate
  }}</korviu-button>
  <korviu-button color="tertiary" (click)="onAcceptClick()" class="w-full">{{
    'common.confirm' | translate
  }}</korviu-button>
</div>
